var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[(!_vm.mobile)?_c('Desktop',{attrs:{"menu":_vm.menu}}):_c('Mobile',{attrs:{"menu":_vm.menu}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }